/**
 * Learning Plan Tiles Item used in the Voucher Redemption page
 */
export class LearningPlanTilesItem {
  constructor(
    public title: string,
    public description: string,
    public url: string,
    public imageIcon: string
  ) {}
}
